import { useCallback } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { PaymentSteps } from '@mopla/data-models';

import { useInternalStore } from '../stores/useInternalStore';
import { usePaymentStepStore } from '../stores/usePaymentStepStore';

export const usePaymentPortalControls = () => {
	const { setPaymentPortalOpened, setPaymentStep, isPaymentPortalOpened } =
		usePaymentStepStore(
			useShallow((state) => ({
				setPaymentPortalOpened: state.setIsOpened,
				isPaymentPortalOpened: state.isOpened,
				setPaymentStep: state.setStep,
			}))
		);
	const { isTrueLayerEnabled, resetTrueLayerInternalStore } = useInternalStore(
		useShallow((state) => ({
			isTrueLayerEnabled: state.isTrueLayerEnabled,
			resetTrueLayerInternalStore: state.reset,
		}))
	);

	const resetPaymentInternalState = useCallback(() => {
		setPaymentStep('selection'); //This is not really needed, bcs the correct payment step is set when opening the portal (see openPaymentPortal)
	}, [setPaymentStep]);

	/** Reset on open, not on close: a close can fire right after the error is set, hiding it. */
	const openPaymentPortal = useCallback(
		(initialStep?: PaymentSteps) => {
			resetTrueLayerInternalStore();
			setPaymentStep(
				initialStep ?? (isTrueLayerEnabled ? 'selection' : 'stripe')
			);
			setPaymentPortalOpened(true);
		},
		[
			isTrueLayerEnabled,
			resetTrueLayerInternalStore,
			setPaymentPortalOpened,
			setPaymentStep,
		]
	);

	const closePaymentPortal = useCallback(() => {
		setPaymentPortalOpened(false);
		resetPaymentInternalState();
	}, [setPaymentPortalOpened, resetPaymentInternalState]);

	return {
		openPaymentPortal,
		closePaymentPortal,
		resetPaymentInternalState,
		setPaymentStep,
		isPaymentPortalOpened,
	};
};
